import styles from "../FooterLinks/FooterLink.module.scss";
import { Spinner } from "react-bootstrap";
import { useEffect, useState } from "react";
import Button from "presentation/components/Button/Button";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import { useTranslation } from 'react-i18next';

const CookieDeclaration = () => {
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const region = useSelector((state: RootState) => state.region.region);
  const LANGUAGEMAP: Record<string, string> = {
    UK: 'en',
    DK: 'da',
    IE: 'en',
    FR: 'fr',
    PT: 'pt'
  };
  const getLanguage = (region: string) => LANGUAGEMAP[region] || 'en';
  
  useEffect(() => {
    const cookiebotId = process.env.REACT_APP_CONSENT_COOKIEBOT_ID;
    if (!cookiebotId) {
      console.warn('Cookiebot Error.');
      setIsLoading(false);
      return;
    }
    const scriptId = "CookieDeclaration";
    const existingScript = document.getElementById(scriptId);
    const language = getLanguage(region);
    if (!existingScript) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src = `https://consent.cookiebot.com/${cookiebotId}/cd.js`;
      script.async = true;
      script.setAttribute('data-culture', language);
      script.onload = () => {
        setIsLoading(false);
      };
      script.onerror = () => {
        console.error('CookieDeclaration script failed to load');
        setIsLoading(false);
      };
      document.getElementById('cookiedeclarationcontainer')?.appendChild(script);
    } else {
      setIsLoading(false);
    }

  }, []);

  return (
    <div className="d-flex justify-content-center align-items-center w-100">

      {isLoading && (
        <div className="d-flex justify-content-center align-items-center vh-100">
          <Spinner animation="border" variant="light" />
        </div>
      )}

      <div className={`${styles.popup} px-5 py-4 mb-2 ${isLoading ? "d-none" : ""}`}>
        <h1>{t('COOKIE_DECLARATION_HEADING')}</h1>
        <div id="cookiedeclarationcontainer"> </div>
        <div className={`${styles.close} float-end mt-3`}>
          <Button label="OK" onClick={() => navigate("/")} />
        </div>
      </div>
    </div>
  );
};

export default CookieDeclaration;
